import React from "react";
import Image from "next/image";
import Link from "next/link";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typograhy from "@mui/material/Typography";
import Carousel from "react-multi-carousel";
import { useMediaQuery, useTheme } from "@mui/material";

import "react-multi-carousel/lib/styles.css";

import RightButton from "./RightButton";
import LeftButton from "./LeftButton";
import { NSApps } from "../../types";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 8,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 8,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 6,
  },
  miniTablet: {
    breakpoint: { max: 768, min: 545 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 545, min: 0 },
    items: 3,
  },
};

const Categories: React.FC<{
  categories: NSApps.ICategoryItem[];
  deviceType: string;
}> = ({ categories, deviceType }) => {
  const theme = useTheme();
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const isUpSm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Container
      maxWidth="xl"
      sx={{
        py: { xs: 8, md: 12 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "& a": {
          textDecoration: "none",
        },
      }}
    >
      {isUpSm && (
        <Typograhy variant="h4" color="text.primary" textAlign="center" pb={8}>
          Discover Use Cases for
        </Typograhy>
      )}
      <Carousel
        responsive={responsive}
        deviceType={deviceType}
        ssr={true}
        infinite={true}
        customRightArrow={<RightButton />}
        customLeftArrow={<LeftButton />}
        renderButtonGroupOutside
      >
        {categories.map((category) => (
          <Link key={category.id} href={`/apps/categories/${category.slug}`}>
            <a>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Image
                    src={category.image}
                    alt={category.name}
                    width={isDownMd ? 45 : 60}
                    height={isDownMd ? 45 : 60}
                  />
                </Box>
                <Box sx={{ display: "flex" }}>
                  <Typograhy
                    variant="h6"
                    textAlign="center"
                    sx={{ minWidth: { xs: 45, md: 60 } }}
                  >
                    {category.name}
                  </Typograhy>
                </Box>
              </Box>
            </a>
          </Link>
        ))}
      </Carousel>
    </Container>
  );
};

export default Categories;
